import { useEffect, useState } from "react";

// Define the type for the hook's return value
type UseReactPath = () => string;

const useReactPath: UseReactPath = () => {
  const [path, setPath] = useState<string>(window.location.pathname);

  const listenToPopstate = () => {
    const winPath = window.location.pathname;
    setPath(winPath);
  };

  useEffect(() => {
    window.addEventListener("popstate", listenToPopstate);

    return () => {
      window.removeEventListener("popstate", listenToPopstate);
    };
  }, []);

  return path;
};

export default useReactPath;
